/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lib_Error_Connectionfailed1Inputs */

const en_lib_error_connectionfailed1 = /** @type {(inputs: Lib_Error_Connectionfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to connect. Please check your internet connection and try again.`)
};

/**
* | output |
* | --- |
* | "Unable to connect. Please check your internet connection and try again." |
*
* @param {Lib_Error_Connectionfailed1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lib_error_connectionfailed1 = /** @type {((inputs?: Lib_Error_Connectionfailed1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lib_Error_Connectionfailed1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lib_error_connectionfailed1(inputs)
});
export { lib_error_connectionfailed1 as "lib.error.connectionFailed" }